import axios from 'axios';
import config from '@/vue-caas/config/config.js';

const baseURI = config.membershipApiUrl;

const userStoreModule = {
  // namespaced: false,

  state: {
    userList: [],
    user: {},
    ownerUser: {},
    chkUser: {},
    userLoginHistoryList: [],
  },
  mutations: {
    SET_STORE_USER_LIST(state, userList) {
      userList === '' ? (state.userList = []) : (state.userList = userList);
    },
    SET_STORE_USER_LOGIN_HISTORY_LIST(state, userLoginHistoryList) {
      userLoginHistoryList === '' ? (state.userLoginHistoryList = []) : (state.userLoginHistoryList = userLoginHistoryList);
    },
    SET_STORE_USER(state, user) {
      user === '' ? (state.user = {}) : (state.user = user);
    },
    SET_STORE_OWNER_USER(state, ownerUser) {
      ownerUser === '' ? (state.ownerUser = {}) : (state.ownerUser = ownerUser);
    },
    SET_STORE_CHK_USER(state, chkUser) {
      chkUser === '' ? (state.chkUser = {}) : (state.chkUser = chkUser);
    },
  },
  actions: {
    getUserList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/list`, params);
        // console.log(`UserList ${(response.data).length}`);
        // console.log(`UserList params ${JSON.stringify(params)}`);
        commit('SET_STORE_USER_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    getLoginUserHistoryList: async ({ commit }, params) => {
      try {
        const query = new URLSearchParams();
        if (params.userId) query.append("userId", params.userId);
        if (params.userIp) query.append("userIp", params.userIp);
        if (params.deviceType) query.append("deviceType", params.deviceType);
        if (params.fromDate) query.append("fromDate", params.fromDate);
        if (params.toDate) query.append("toDate", params.toDate);
        if (params.pageNum) query.append("pageNum", params.pageNum);
        if (params.pageRows) query.append("pageRows", params.pageRows);
        let url = `${baseURI}/membership/userLoginHistory/list?${query.toString()}`;
        const response = await axios.get(url);
        commit('SET_STORE_USER_LOGIN_HISTORY_LIST', response.data);
      } catch (error) {
        console.log(error);
      }
    },
    getUser: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/info`, params);
        // console.log(response.data);
        await commit('SET_STORE_USER', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    getOwnerUser: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/info`, params);
        // console.log(response.data);
        await commit('SET_STORE_OWNER_USER', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    insertUser: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/insert`, params);
        await commit('SET_STORE_USER_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    insertUserLoginHistory: async ({ commit }, params) => {
      try {
        await axios.post(`${baseURI}/membership/insertUserLoginHistory`, params);
      } catch (err) {
        console.log(err);
      }
    },
    updateUser: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/update`, params);
        // console.log(response.data);
        await commit('SET_STORE_USER_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    logoutUserLoginHistory: async ({ commit }) => {
      try {
        await axios.post(`${baseURI}/membership/logoutUserLoginHistory`);
      } catch (err) {
        console.log(err);
      }
    },
    deleteUsr: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/delete`, params);
        // console.log(response.data);
        await commit('SET_STORE_USER_LIST', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    checkUser: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/check`, params);
        // console.log(response.data);
        await commit('SET_STORE_CHK_USER', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    updateMyAcc: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/myacc/update`, params);
        // console.log(response.data);
        await commit('SET_STORE_USER', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    checkPassword: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/myacc/checkpwd`, params);
        // console.log(response.data);
        await commit('SET_STORE_USER', response.data);
      } catch (err) {
        // console.log(ex);
        // alert(err);
        throw err;
      }
    },
    // 관리자 OTP 초기화 / 잠금 해제 (응답에 비밀키·QR 없음, store 에 저장하지 않음)
    getOtpStatus: async ({ commit }, params) => {
      const response = await axios.post(`${baseURI}/user/otp/status`, params);
      return response.data;
    },
    resetOtp: async ({ commit }, params) => {
      const response = await axios.post(`${baseURI}/user/otp/reset`, params);
      return response.data;
    },
    unlockOtp: async ({ commit }, params) => {
      const response = await axios.post(`${baseURI}/user/otp/unlock`, params);
      return response.data;
    },
    forgotPassword: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/forgot-password`, params);
        console.log('Call API forgotPassword', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    resetPassword: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/user/reset-password`, params);
        console.log('Call API resetPassword', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    userList: (state) => state.userList,
    userLoginHistoryList: (state) => state.userLoginHistoryList,
    user: (state) => state.user,
    ownerUser: (state) => state.ownerUser,
    chkUser: (state) => state.chkUser,
  },
};

export default userStoreModule;
